module.exports = __webpack_public_path__ + "images/end-point-icon.ca61b7d4e2417d28aed7e60967674ec7.png";